import { Col, Row } from "react-bootstrap";
import "./intro.css";
import placeholder from "@/assets/placeholder.webp";
import ArrowButton from "@/components/common/buttons/ArrowButton";

interface Props {
  onClick: () => void;
}

const ContactIntro = ({ onClick }: Props) => {
  return (
    <div className="intro-row">
      <Row className="body-row">
        <Col xs={12} lg={6} className="contact-info">
          <Row className="stack-one">
            <Row className="contact-head eyebrow-body">Contact</Row>
            <h1 className="title-2">
              Contactează-ne să discutăm mai multe despre viitorul proiect
            </h1>
          </Row>
          <Row className="body contact-text">
            Spune-ne ce vrei să construiești și pregătește-te să uiți de
            compromisuri. Lucrăm doar cu cei care vor rezultate mari și nu se
            tem să iasă din turmă. Împreună facem ceva ce merită să fie văzut.
          </Row>
        </Col>
        <Col className="img-col" xs={12} lg={6}>
          <div className="contact-img-wrapper">
            <img src={placeholder} className="contact-img" alt="Pixado" />
          </div>
          <ArrowButton onClick={onClick} className="contact-decor" />
        </Col>
      </Row>
    </div>
  );
};

export default ContactIntro;
